<template functional>
    <div v-if="props.discontinued" class="product-card__discontinued has-tooltip">
        <span>{{ props.translations["discontinued"] }}</span>
        <i class="fas fa-info-circle"></i>
        <span class="tooltip" v-html="props.translations['discontinuedInfoMsg']"></span>
    </div>
    <div v-else-if="props.price" class="product-card__price" :class="{
        'product-card__price--promo': props.priceFetched && props.hasPromo,
        'product-card__price--default': props.priceFetched && !props.hasPromo,
        'product-card__price--fetching': !props.priceFetched
    }">
        <template v-if="props.priceFetched && props.hasPromo">
            <span>{{ props.translations["promotionPrice"] }}:</span>
            <strong>{{ props.price }}</strong>
        </template>
        <template v-else-if="props.priceFetched">
            <span>{{ props.translations["yourPrice"] }}:</span>
            <strong>{{ props.price }}</strong>
        </template>
        <template v-else>
            <span>{{ props.translations["price"] }}:</span>
            <strong>{{ props.price }}</strong>
        </template>
    </div>
</template>

<script>
// We put this in a separate component as this optmizes the Vue rendering which interferes with the numerical input events from the qty input
// Functional component to keep it lightweight -> component has no this or reactivity, only context which provides us with props, etc.
export default {
    name: "ProductPrice",
    
    props: {
        hasPromo: {
            type: Boolean,
            default: false
        },
        priceFetched: {
            type: Boolean,
            required: true
        },
        price: {
            type: [String, null]
        },
        discontinued: {
            type: Boolean,
            default: false
        },
        translations: {
            type: Object,
            default: () => {
                return {
                    'price': 'Prijs',
                    'promotionPrice': 'Promotieprijs',
                    'yourPrice': 'Uw prijs',
                    'discontinuedInfoMsg': 'Volgende artikel is niet meer beschikbaar. Klik op het mandje om het alternatief te bekijken en te bestellen.',
                    'discontinued': 'Niet beschikbaar'
                }
            }
        }
    }
}
</script>

<style scoped>
.has-tooltip {
    @apply relative cursor-pointer md:justify-end;
    
    .tooltip {
        @apply hidden;
    }
    
    &:hover .tooltip {
        @apply block text-left;
    }
}
</style>